import React from "react";

import { useTranslation } from "react-i18next";

import { SelectItem } from "@/uiKit/atoms/inputs/SelectItem.tsx";
import { FormSelectInput } from "@/uiKit/molecules/form/FormSelectInput.tsx";

export type PrescriptionDurationFormFieldProps = {
  name?: string;
  translationMapping: (value: "1" | "2" | "3") => string;
  className?: string;
};

export const PrescriptionDurationFormField: React.FC<PrescriptionDurationFormFieldProps> = ({
  name = "duration",
  translationMapping,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <FormSelectInput
      id="prescription-duration-form-field"
      name={name}
      label={t("diabetesForms.prescriptionDuration")}
      fullWidth
      reserveErrorSpace
      className={className}
    >
      <SelectItem value="1">{translationMapping("1")}</SelectItem>
      <SelectItem value="2">{translationMapping("2")}</SelectItem>
      <SelectItem value="3">{translationMapping("3")}</SelectItem>
    </FormSelectInput>
  );
};
